<script setup>
import { computed, defineEmits, defineProps, onBeforeUnmount, onMounted, ref } from 'vue';

const props = defineProps({
  isAdmin: Boolean,
  selectedUserId: String
});

const emit = defineEmits(['filterChanged', 'favoritesToggled']);

const isMobile = ref(window.innerWidth <= 767);
const updateResolution = () => {
  isMobile.value = window.innerWidth <= 767;
};

onMounted(() => {
  window.addEventListener('resize', updateResolution);
});

onBeforeUnmount(() => {
  window.removeEventListener('resize', updateResolution);
});

const activeLegend = ref(null);
const favoritesActive = ref(false);

const allLegends = [
  { text: 'Unclaimed', color: 'white', textColor: '', filter: 'unclaimed' },
  { text: 'Claimed', color: '#D7DEFF', textColor: 'text-primary', filter: 'claimedbyme' },
  { text: 'Claimed by others', color: '#FFF4D7', textColor: '', filter: 'claimedbyothers' },
  { text: '★ Favorites', color: '#F3E8FF', textColor: 'text-primary', filter: 'favorites' }
];

const legends = computed(() => {
  if (props.isAdmin) return allLegends;
  return allLegends.filter(
    legend => legend.text !== '★ Favorites' && legend.text !== 'Claimed by others'
  );
});

function handleClick(legend) {
  if (legend.text === '★ Favorites') {
    favoritesActive.value = !favoritesActive.value;
    emit('favoritesToggled', favoritesActive.value);
  } else {
    if (activeLegend.value === legend.text) {
      activeLegend.value = null;
      emit('filterChanged', null);
    } else {
      activeLegend.value = legend.text;
      emit('filterChanged', legend.filter);
    }
  }
}

function isActive(legend) {
  return legend.text === '★ Favorites'
    ? favoritesActive.value
    : activeLegend.value === legend.text;
}
</script>

<template>
  <div id="VVVClaimsListLegend"
    class="d-flex justify-content-start align-items-center gap-3 ps-2 ps-lg-0 overflow-x-auto py-3">
    <p class="text-uppercase fw-bold text-center my-auto text-black m-0" style="font-size: 13px;">
      Quick Filters:
    </p>

    <template v-for="legend in legends" :key="legend.text">
      <div class="px-3 py-2 rounded-5 shadow-sm text-nowrap legend-item" :style="[
        {
          fontSize: '12px',
          background: legend.color,
          border: isActive(legend) ? '2px solid #223698' : 'none'
        }
      ]" @click="handleClick(legend)" style="cursor: pointer;">
        <p class="align-middle text-center m-auto text-uppercase fw-bold" :class="legend.textColor"
          style="font-size: 11px;">
          {{ legend.text }} {{ legend.text === 'Claimed' && props.isAdmin ? 'by you' : '' }}
        </p>
      </div>
    </template>
  </div>
</template>

<style>
:root {
  --white: #ffffff;
  --primary: #223698;
  --secondary: #e2e6ef;
  --accent: #02061b;
  --blue: #1f87fc;
}

.text-primary {
  color: var(--primary) !important;
}
</style>